import { Medal } from "lucide-react";
import { useSiteLogo } from "@/lib/siteConfig";

export const SiteLogo = ({ className = "w-8 h-8" }) => {
  const logo = useSiteLogo();
  if (logo) {
    return <img src={logo} alt="Logo OPES Ginnastiche" data-testid="site-logo" className={`${className} object-contain rounded-md`} />;
  }
  return <Medal className={`${className} text-gold`} />;
};
